// Hooks / Node modules / Styles
import {
  Header,
  useIsMobile,
  Drawer,
  DrawerToggler,
  useDrawer,
  Sidebar,
} from "elseware-ui";
import { useNavigate } from "react-router-dom";

// Reducers / Actions

// Utils / Functions

// Components
import HeaderNav from "../header-nav/HeaderNav";
import CustomBrand from "../custom-brand/CustomBrand";
import UserLogPortal from "./_com/UserLogPortal";

// Sub-Components

// Data / Images / Icons
import header_nav from "src/data/nav/header_nav";
import header_nav_mobile from "src/data/nav/header_nav_mobile";

function CustomHeader() {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { show, openDrawer, closeDrawer } = useDrawer(false);

  return (
    <Header position="fixed" styles="px-3">
      {/* <div className="flex flex-row items-center w-full justify-between px-5 shadow-md border-b border-b-gray-300 dark:border-b-success-500 bg-gray-200 dark:bg-dark-900"> */}
      <div className="flex flex-row items-center justify-between">
        <CustomBrand />
        {!isMobile && (
          <div className="flex flex-row items-center w-full justify-between px-3">
            <HeaderNav data={header_nav} navigate={navigate} />
            <UserLogPortal />
          </div>
        )}
        {isMobile && <DrawerToggler toggleDrawer={openDrawer} />}
      </div>

      {/* Sidebar */}
      <Drawer side="right" visibility={show} handleClose={closeDrawer} styles="flex flex-col justify-between pb-[70px]">
        <Sidebar data={header_nav_mobile} />

        <UserLogPortal />
      </Drawer>
      {/* </div> */}
    </Header>
  );
}

export default CustomHeader;
